(function () {
  let currentOpenId = null;
  let prevOverflowBody = '';
  let prevOverflowHtml = '';
  let savedScrollY = 0;

  function setVideoSrcIfNeeded(videoEl) {
    if (!videoEl) return;
    const srcEl = videoEl.querySelector('source');
    if (srcEl && !srcEl.getAttribute('src')) {
      const lazy = srcEl.getAttribute('data-src');
      if (lazy) {
        srcEl.setAttribute('src', lazy);
        try { videoEl.load(); } catch (_) { }
      }
    }
  }

  function lockScroll() {
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;

    prevOverflowBody = document.body.style.overflow;
    prevOverflowHtml = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';

    document.body.classList.add('is-modal-open');
    document.documentElement.classList.add('is-modal-open');

    document.body.classList.remove('overflow-auto', 'overflow-scroll', 'overflow-visible');
    document.documentElement.classList.remove('overflow-auto', 'overflow-scroll', 'overflow-visible');
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    document.body.style.overflow = prevOverflowBody || '';
    document.documentElement.style.overflow = prevOverflowHtml || '';
    document.body.classList.remove('is-modal-open', 'overflow-hidden', 'fixed');
    document.documentElement.classList.remove('is-modal-open', 'overflow-hidden', 'fixed');


    const html = document.documentElement;
    const prevScrollBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    window.scrollTo(0, savedScrollY);

    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevScrollBehavior || '';
    });
  }

  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.remove('dy:hidden');
    modal.setAttribute('aria-hidden', 'false');
    currentOpenId = id;

    lockScroll();

    const video = modal.querySelector('video');
    setVideoSrcIfNeeded(video);
    if (video) {
      // Muted + inline is what browsers (incl. iOS Safari) allow to start on their own.
      video.muted = true;
      video.setAttribute('playsinline', '');
      const playing = video.play();
      if (playing && typeof playing.catch === 'function') {
        playing.catch(() => {
          // The source was only just attached: retry once it can play, if still open.
          video.addEventListener('canplay', () => {
            if (currentOpenId === id) video.play().catch(() => {});
          }, { once: true });
        });
      }
    }
  }

  function closeModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.add('dy:hidden');
    modal.setAttribute('aria-hidden', 'true');

    const video = modal.querySelector('video');
    if (video) { try { video.pause(); } catch (_) { } video.currentTime = 0; }

    currentOpenId = null;
    unlockScroll();
  }

  function getOpenModal() {
    if (!currentOpenId) return null;
    return document.getElementById(currentOpenId);
  }

  document.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeModal(closer.getAttribute('data-close'));
      return;
    }

    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-open'));
      return;
    }

    const openModalEl = getOpenModal();
    if (!openModalEl) return;

    // Keep open when interacting with dialog content (new 2-col panels or legacy video-only)
    if (e.target.closest('[data-modal-panel], video')) return;

    closeModal(openModalEl.id);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openModalEl = getOpenModal();
      if (openModalEl) closeModal(openModalEl.id);
    }
  });
})();
